import React, { lazy } from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";

const AgentsList = lazy(() => import("../../container/pages/agents/index"));

function AgentsRoute() {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route path={`${path}`} component={AgentsList} />
    </Switch>
  );
}

export default AgentsRoute;
